import { useState, useEffect } from 'react';
import { Box } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { useTheme } from "@mui/material";
import { API_BASE_URL } from "../../config/api";

const Contacts = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch data from API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (!token) {
          throw new Error('No authentication token found');
        }

        const response = await fetch(`${API_BASE_URL}/admin/alias/getAll`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (!response.ok) {
          throw new Error(`API request failed with status ${response.status}`);
        }

        const jsonData = await response.json();
        
        // Transform data to match DataGrid requirements
        const transformedData = jsonData.items.map(item => ({
          id: item._id,       // MUI DataGrid requires 'id' field
          name: item.name,
          quote_api: item.quote_api,
          book_api: item.book_api,
          update_api: item.update_api
        }));

        setData(transformedData);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Define columns for the new data structure
  const columns = [
    { field: "id", headerName: "ID", flex: 0.5 },
    { 
      field: "name", 
      headerName: "Name", 
      flex: 1,
      cellClassName: "name-column--cell" 
    },
    { 
      field: "quote_api", 
      headerName: "Quote API", 
      flex: 1 
    },
    { 
      field: "book_api", 
      headerName: "Book API", 
      flex: 1 
    },
    { 
      field: "update_api", 
      headerName: "Update API", 
      flex: 1 
    },
  ];

  return (
    <Box m="20px">
      <Header
        title="Alias"
        subtitle="List of all afiliated alias"
      />
      
      {error && (
        <Box color={colors.redAccent[500]} p={2} mb={2}>
          Error: {error}
        </Box>
      )}

      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid
          rows={data}
          columns={columns}
          loading={loading}
          components={{ Toolbar: GridToolbar }}
        />
      </Box>
    </Box>
  );
};

export default Contacts;